import { IconButton, IconButtonProps } from "@mui/material";
import { FC } from "react";

export const MuiIconButton: FC<IconButtonProps> = props => {
  return <IconButton {...props} />;
};
